import { useNavigate } from 'react-router-dom';
import { ArrowLeft, HeartPulse } from 'lucide-react';
import AppShell from '../layouts/AppShell';
import UserProfileButton from '../components/UserProfileButton';
import EmptyState from '../components/EmptyState';
import SubmittedNoteCard from '../components/SubmittedNoteCard';
import { getNotePatientDisplayName } from '../constants/mockPatients';
import { getNoteTypeLabel } from '../utils/noteTypeLabels';
import { useSession } from '../contexts/SessionContext';
import { useLanguage } from '../contexts/LanguageContext';
import { vitalPath } from '../constants/routes';

export default function VitalsListScreen() {
  const navigate = useNavigate();
  const { vitalsNotes, admittedPatients } = useSession();
  const { t, language } = useLanguage();

  return (
    <AppShell>
      <header className="sticky top-0 z-30 border-b border-gray-200 bg-surface px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <button type="button" onClick={() => navigate(-1)} className="text-primary" aria-label={t('back')}>
              <ArrowLeft className="h-5 w-5" />
            </button>
            <div>
              <h1 className="text-page-title">{t('vitals')}</h1>
              <p className="text-xs text-gray-500">{t('notesChronological')}</p>
            </div>
          </div>
          <UserProfileButton />
        </div>
      </header>

      <div className="space-y-3 px-4 py-4">
        {vitalsNotes.length === 0 ? (
          <EmptyState icon={HeartPulse} title={t('noVitalsYet')} />
        ) : (
          vitalsNotes.map((note) => (
            <SubmittedNoteCard
              key={note.id}
              patientName={getNotePatientDisplayName(note, admittedPatients, language)}
              noteType={note.note_type}
              noteTypeLabel={getNoteTypeLabel(note.note_type, language)}
              note={note}
              onOpen={() => navigate(vitalPath(note.id), { state: { note } })}
              viewLabel={t('view')}
            />
          ))
        )}
      </div>
    </AppShell>
  );
}
